import { useTranslation } from "react-i18next";
import { useToastNotifications } from "@/shared/coralreef";

export const SIGN_IN_FAILED = "Sign-in failed";

export function useErrorToast() {
  const { t } = useTranslation();
  const { addToast } = useToastNotifications();

  const toast = (message: string) => addToast(message, "error");

  const errorMessage = (e: unknown, fallback: string) =>
    e instanceof Error ? e.message : t(fallback);

  const toastError = (e: unknown, fallback: string) =>
    toast(errorMessage(e, fallback));

  const toastOnFailure = (work: Promise<unknown>, fallback: string) => {
    work.catch((e) => toastError(e, fallback));
  };

  return { toast, errorMessage, toastError, toastOnFailure };
}
